import React from 'react';

export const Row: React.FC = ({ children }) => (
  <div className="grid grid-flow-row col-span-12 auto-rows-min md:grid-flow-col md:auto-cols-fr gap-y-3 md:gap-y-0 md:gap-x-8">
    {children}
  </div>
);
